import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'role'
})
export class RolePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    // Value is too short
    if (value.length <= 5) {
      return value;
    }

    return value.substr(5, value.length);
  }

}
